// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Thanks Giving Monitoring — Excel-style report table */

.tg-monitor-page {
  padding: 24px;
}

.tg-monitor-header {
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.tg-report-radio {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.tg-radio-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.tg-radio-option input {
  margin: 0;
  accent-color: #2563eb;
}

.tg-radio-option.active {
  background: #fff;
  color: #1e40af;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.tg-radio-option.tg-radio-disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.tg-empty-state .filter-btn {
  margin-top: 12px;
}

.tg-filters-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 14px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.tg-filters-bar .filter-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #4a5568;
  margin: 0;
}

.tg-date-input,
.tg-filter-select,
.tg-ricef-select {
  min-width: 150px;
  height: 38px;
  box-sizing: border-box;
}

.tg-filter-ricef {
  flex: 1 1 220px;
  min-width: 200px;
  max-width: 360px;
}

.tg-ricef-select {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.tg-filter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-end;
}

.tg-submit-btn {
  height: 38px;
  padding: 0 18px;
  background: #3182ce;
  color: #fff;
  border: 1px solid #3182ce;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.tg-submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tg-submit-btn:hover:not(:disabled) {
  background: #2b6cb0;
  border-color: #2b6cb0;
}

.tg-download-btn {
  height: 38px;
  padding: 0 18px;
  background: #fff;
  color: #1e40af;
  border: 1px solid #93c5fd;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.tg-download-btn:hover:not(:disabled) {
  background: #eff6ff;
  border-color: #60a5fa;
}

.tg-download-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tg-empty-state {
  padding: 48px 24px;
  text-align: center;
  color: #64748b;
  background: #fff;
}

.tg-empty-state p {
  margin: 0;
  font-size: 15px;
}

.tg-monitor-table-container {
  padding: 0;
  overflow: hidden;
}

.tg-monitor-scroll {
  overflow: auto;
  max-height: calc(100vh - 240px);
  max-height: calc(100dvh - 240px);
  -webkit-overflow-scrolling: touch;
}

.tg-monitor-table {
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12px;
  min-width: 1400px;
}

.tg-monitor-table th,
.tg-monitor-table td {
  border: 1px solid #94a3b8;
  padding: 6px 8px;
  vertical-align: top;
  background-clip: padding-box;
}

/* Sticky left columns — opaque so scrolling metrics never bleed through */
.tg-sticky {
  position: sticky;
  z-index: 3;
  background: #dcfce7;
}

.tg-sticky-1 {
  left: 0;
  min-width: 260px;
  max-width: 280px;
  width: 260px;
  z-index: 5;
}

.tg-sticky-2 {
  left: 260px;
  min-width: 160px;
  max-width: 200px;
  width: 160px;
  z-index: 4;
}

.tg-sticky-3 {
  left: 420px;
  min-width: 130px;
  max-width: 150px;
  width: 130px;
  z-index: 4;
  box-shadow: 4px 0 8px -2px rgba(15, 23, 42, 0.18);
}

thead .tg-sticky {
  z-index: 10;
  top: auto;
}

/* Header colors (Excel-like) */
.tg-th-ricef {
  background: #fde047 !important;
  color: #1a202c;
  font-weight: 700;
  text-align: center;
  vertical-align: middle;
}

.tg-th-blank {
  background: #fde047 !important;
}

.tg-th-dir-label,
.tg-th-variant-label {
  background: #fde047 !important;
  color: #1a202c;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
}

.tg-th-caption {
  background: #93c5fd !important;
  color: #0f172a;
  font-weight: 600;
  text-align: left;
  white-space: normal;
  line-height: 1.3;
}

.tg-th-subcaption {
  background: #60a5fa !important;
  color: #fff;
  font-weight: 600;
  text-align: left;
  white-space: normal;
  line-height: 1.3;
}

.tg-th-group {
  background: #facc15 !important;
  color: #1a202c;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
}

.tg-th-time {
  background: #fde047 !important;
  color: #1a202c;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  font-size: 11px;
  vertical-align: middle;
}

.tg-th-metric {
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  font-size: 10px;
  min-width: 72px;
  vertical-align: middle;
}

.tg-metric-success {
  background: #86efac !important;
  color: #14532d;
}

.tg-metric-error {
  background: #fca5a5 !important;
  color: #7f1d1d;
}

.tg-metric-total {
  background: #e2e8f0 !important;
  color: #334155;
}

.tg-metric-pending {
  background: #ffedd5 !important;
  color: #9a3412;
}

/* Body cells */
.tg-cell-ricef {
  font-weight: 600;
  color: #0f172a;
  background: #dcfce7 !important;
}

.tg-cell-dir {
  font-size: 11px;
  line-height: 1.35;
  color: #334155;
  background: #dcfce7 !important;
}

.tg-cell-variant {
  font-weight: 600;
  color: #1e3a8a;
  background: #dcfce7 !important;
}

.tg-cell-scroll,
.tg-dir-text {
  display: block;
  max-height: 4.8em;
  overflow-x: hidden;
  overflow-y: auto;
  white-space: pre-line;
  word-break: break-word;
  line-height: 1.35;
  -webkit-overflow-scrolling: touch;
}

.tg-cell-variant .tg-cell-scroll {
  white-space: normal;
  max-height: 3.6em;
}

.tg-cell-metric {
  text-align: right;
  font-variant-numeric: tabular-nums;
  background: #f0fdf4;
  white-space: nowrap;
  vertical-align: middle;
}

.tg-cell-currency {
  text-align: left;
  font-size: 10px;
  white-space: normal;
  min-width: 150px;
  line-height: 1.35;
  max-width: 200px;
}

/* Each currency (USD / CAD) stays unbroken on its own line */
.tg-currency-line {
  display: block;
  white-space: nowrap;
}

/* Success = green, Failed = dark red, Pending = light orange */
.tg-cell-success {
  color: #166534 !important;
  background: #dcfce7 !important;
  font-weight: 600;
}

.tg-cell-error {
  color: #b91c1c !important;
  background: #fee2e2 !important;
  font-weight: 600;
}

.tg-cell-pending {
  color: #9a3412 !important;
  background: #ffedd5 !important;
  font-weight: 600;
}

.tg-row-summary .tg-cell-ricef,
.tg-row-summary .tg-cell-dir,
.tg-row-summary .tg-cell-variant {
  background: #bbf7d0 !important;
}

.tg-row-summary .tg-cell-metric {
  background: #bbf7d0;
  font-weight: 600;
}

.tg-row-summary .tg-cell-success {
  background: #86efac !important;
}

.tg-row-summary .tg-cell-error {
  background: #fecaca !important;
  color: #b91c1c !important;
}

.tg-row-total td {
  background: #86efac !important;
  font-weight: 700;
}

.tg-row-total .tg-cell-success {
  background: #4ade80 !important;
  color: #14532d !important;
}

.tg-row-total .tg-cell-error {
  background: #f87171 !important;
  color: #7f1d1d !important;
}

.tg-row-total .tg-cell-pending {
  background: #ffd8a8 !important;
  color: #9a3412 !important;
}

.tg-row-proxy td {
  background: #ecfccb;
}

.tg-row-proxy .tg-sticky {
  background: #ecfccb !important;
}

.tg-row-section td {
  background: #1e40af !important;
  color: #fff !important;
  font-weight: 700;
  text-align: left;
  padding: 10px 12px;
}

.tg-row-idoc:hover .tg-cell-metric:not(.tg-cell-success):not(.tg-cell-error):not(.tg-cell-pending) {
  background: #bbf7d0;
}

.tg-row-idoc:hover .tg-sticky {
  background: #bbf7d0 !important;
}

/* Dark theme */
[data-theme="dark"] .tg-filters-bar,
[data-theme="dark"] .tg-report-radio {
  background: var(--surface);
  border-color: var(--border);
}

[data-theme="dark"] .tg-radio-option.active {
  background: var(--surface-2);
  color: var(--primary);
}

[data-theme="dark"] .tg-monitor-table th,
[data-theme="dark"] .tg-monitor-table td {
  border-color: var(--border-strong);
}

/* Mobile */
@media (max-width: 768px) {
  .tg-monitor-page {
    padding: 12px;
  }

  .tg-monitor-header {
    flex-direction: column;
    align-items: stretch;
  }

  .tg-report-radio {
    width: 100%;
    justify-content: stretch;
  }

  .tg-radio-option {
    flex: 1 1;
    justify-content: center;
  }

  .tg-filters-bar {
    padding: 12px;
  }

  .tg-filters-bar .filter-label {
    flex: 1 1 100%;
  }

  .tg-date-input,
  .tg-filter-select,
  .tg-ricef-select {
    min-width: 0;
    width: 100%;
  }

  .tg-filter-ricef {
    max-width: none;
  }

  .tg-filter-actions {
    width: 100%;
  }

  .tg-submit-btn,
  .tg-download-btn {
    flex: 1 1;
  }

  .tg-monitor-scroll {
    max-height: calc(100dvh - 280px);
  }

  .tg-sticky-1 {
    min-width: 160px;
    max-width: 170px;
    width: 160px;
  }

  .tg-sticky-2 {
    left: 160px;
    min-width: 100px;
    max-width: 110px;
    width: 100px;
  }

  .tg-sticky-3 {
    left: 260px;
    min-width: 90px;
    max-width: 100px;
    width: 90px;
  }

  .tg-th-metric {
    min-width: 64px;
    font-size: 9px;
  }

  .tg-monitor-table {
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/thanksgiving-monitoring/index.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,0EAA0E;AAC1E;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,eAAe;AACf;;EAEE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;;;IAGE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,SAAO;EACT;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Thanks Giving Monitoring — Excel-style report table */\n\n.tg-monitor-page {\n  padding: 24px;\n}\n\n.tg-monitor-header {\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.tg-report-radio {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n}\n\n.tg-radio-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748b;\n  cursor: pointer;\n  user-select: none;\n}\n\n.tg-radio-option input {\n  margin: 0;\n  accent-color: #2563eb;\n}\n\n.tg-radio-option.active {\n  background: #fff;\n  color: #1e40af;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n\n.tg-radio-option.tg-radio-disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.tg-empty-state .filter-btn {\n  margin-top: 12px;\n}\n\n.tg-filters-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 12px;\n  margin-bottom: 14px;\n  padding: 14px 16px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n}\n\n.tg-filters-bar .filter-label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  color: #4a5568;\n  margin: 0;\n}\n\n.tg-date-input,\n.tg-filter-select,\n.tg-ricef-select {\n  min-width: 150px;\n  height: 38px;\n  box-sizing: border-box;\n}\n\n.tg-filter-ricef {\n  flex: 1 1 220px;\n  min-width: 200px;\n  max-width: 360px;\n}\n\n.tg-ricef-select {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.tg-filter-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: flex-end;\n}\n\n.tg-submit-btn {\n  height: 38px;\n  padding: 0 18px;\n  background: #3182ce;\n  color: #fff;\n  border: 1px solid #3182ce;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.tg-submit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.tg-submit-btn:hover:not(:disabled) {\n  background: #2b6cb0;\n  border-color: #2b6cb0;\n}\n\n.tg-download-btn {\n  height: 38px;\n  padding: 0 18px;\n  background: #fff;\n  color: #1e40af;\n  border: 1px solid #93c5fd;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.tg-download-btn:hover:not(:disabled) {\n  background: #eff6ff;\n  border-color: #60a5fa;\n}\n\n.tg-download-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.tg-empty-state {\n  padding: 48px 24px;\n  text-align: center;\n  color: #64748b;\n  background: #fff;\n}\n\n.tg-empty-state p {\n  margin: 0;\n  font-size: 15px;\n}\n\n.tg-monitor-table-container {\n  padding: 0;\n  overflow: hidden;\n}\n\n.tg-monitor-scroll {\n  overflow: auto;\n  max-height: calc(100vh - 240px);\n  max-height: calc(100dvh - 240px);\n  -webkit-overflow-scrolling: touch;\n}\n\n.tg-monitor-table {\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 12px;\n  min-width: 1400px;\n}\n\n.tg-monitor-table th,\n.tg-monitor-table td {\n  border: 1px solid #94a3b8;\n  padding: 6px 8px;\n  vertical-align: top;\n  background-clip: padding-box;\n}\n\n/* Sticky left columns — opaque so scrolling metrics never bleed through */\n.tg-sticky {\n  position: sticky;\n  z-index: 3;\n  background: #dcfce7;\n}\n\n.tg-sticky-1 {\n  left: 0;\n  min-width: 260px;\n  max-width: 280px;\n  width: 260px;\n  z-index: 5;\n}\n\n.tg-sticky-2 {\n  left: 260px;\n  min-width: 160px;\n  max-width: 200px;\n  width: 160px;\n  z-index: 4;\n}\n\n.tg-sticky-3 {\n  left: 420px;\n  min-width: 130px;\n  max-width: 150px;\n  width: 130px;\n  z-index: 4;\n  box-shadow: 4px 0 8px -2px rgba(15, 23, 42, 0.18);\n}\n\nthead .tg-sticky {\n  z-index: 10;\n  top: auto;\n}\n\n/* Header colors (Excel-like) */\n.tg-th-ricef {\n  background: #fde047 !important;\n  color: #1a202c;\n  font-weight: 700;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.tg-th-blank {\n  background: #fde047 !important;\n}\n\n.tg-th-dir-label,\n.tg-th-variant-label {\n  background: #fde047 !important;\n  color: #1a202c;\n  font-weight: 700;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.tg-th-caption {\n  background: #93c5fd !important;\n  color: #0f172a;\n  font-weight: 600;\n  text-align: left;\n  white-space: normal;\n  line-height: 1.3;\n}\n\n.tg-th-subcaption {\n  background: #60a5fa !important;\n  color: #fff;\n  font-weight: 600;\n  text-align: left;\n  white-space: normal;\n  line-height: 1.3;\n}\n\n.tg-th-group {\n  background: #facc15 !important;\n  color: #1a202c;\n  font-weight: 700;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.tg-th-time {\n  background: #fde047 !important;\n  color: #1a202c;\n  font-weight: 700;\n  text-align: center;\n  white-space: nowrap;\n  font-size: 11px;\n  vertical-align: middle;\n}\n\n.tg-th-metric {\n  font-weight: 600;\n  text-align: center;\n  white-space: nowrap;\n  font-size: 10px;\n  min-width: 72px;\n  vertical-align: middle;\n}\n\n.tg-metric-success {\n  background: #86efac !important;\n  color: #14532d;\n}\n\n.tg-metric-error {\n  background: #fca5a5 !important;\n  color: #7f1d1d;\n}\n\n.tg-metric-total {\n  background: #e2e8f0 !important;\n  color: #334155;\n}\n\n.tg-metric-pending {\n  background: #ffedd5 !important;\n  color: #9a3412;\n}\n\n/* Body cells */\n.tg-cell-ricef {\n  font-weight: 600;\n  color: #0f172a;\n  background: #dcfce7 !important;\n}\n\n.tg-cell-dir {\n  font-size: 11px;\n  line-height: 1.35;\n  color: #334155;\n  background: #dcfce7 !important;\n}\n\n.tg-cell-variant {\n  font-weight: 600;\n  color: #1e3a8a;\n  background: #dcfce7 !important;\n}\n\n.tg-cell-scroll,\n.tg-dir-text {\n  display: block;\n  max-height: 4.8em;\n  overflow-x: hidden;\n  overflow-y: auto;\n  white-space: pre-line;\n  word-break: break-word;\n  line-height: 1.35;\n  -webkit-overflow-scrolling: touch;\n}\n\n.tg-cell-variant .tg-cell-scroll {\n  white-space: normal;\n  max-height: 3.6em;\n}\n\n.tg-cell-metric {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  background: #f0fdf4;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.tg-cell-currency {\n  text-align: left;\n  font-size: 10px;\n  white-space: normal;\n  min-width: 150px;\n  line-height: 1.35;\n  max-width: 200px;\n}\n\n/* Each currency (USD / CAD) stays unbroken on its own line */\n.tg-currency-line {\n  display: block;\n  white-space: nowrap;\n}\n\n/* Success = green, Failed = dark red, Pending = light orange */\n.tg-cell-success {\n  color: #166534 !important;\n  background: #dcfce7 !important;\n  font-weight: 600;\n}\n\n.tg-cell-error {\n  color: #b91c1c !important;\n  background: #fee2e2 !important;\n  font-weight: 600;\n}\n\n.tg-cell-pending {\n  color: #9a3412 !important;\n  background: #ffedd5 !important;\n  font-weight: 600;\n}\n\n.tg-row-summary .tg-cell-ricef,\n.tg-row-summary .tg-cell-dir,\n.tg-row-summary .tg-cell-variant {\n  background: #bbf7d0 !important;\n}\n\n.tg-row-summary .tg-cell-metric {\n  background: #bbf7d0;\n  font-weight: 600;\n}\n\n.tg-row-summary .tg-cell-success {\n  background: #86efac !important;\n}\n\n.tg-row-summary .tg-cell-error {\n  background: #fecaca !important;\n  color: #b91c1c !important;\n}\n\n.tg-row-total td {\n  background: #86efac !important;\n  font-weight: 700;\n}\n\n.tg-row-total .tg-cell-success {\n  background: #4ade80 !important;\n  color: #14532d !important;\n}\n\n.tg-row-total .tg-cell-error {\n  background: #f87171 !important;\n  color: #7f1d1d !important;\n}\n\n.tg-row-total .tg-cell-pending {\n  background: #ffd8a8 !important;\n  color: #9a3412 !important;\n}\n\n.tg-row-proxy td {\n  background: #ecfccb;\n}\n\n.tg-row-proxy .tg-sticky {\n  background: #ecfccb !important;\n}\n\n.tg-row-section td {\n  background: #1e40af !important;\n  color: #fff !important;\n  font-weight: 700;\n  text-align: left;\n  padding: 10px 12px;\n}\n\n.tg-row-idoc:hover .tg-cell-metric:not(.tg-cell-success):not(.tg-cell-error):not(.tg-cell-pending) {\n  background: #bbf7d0;\n}\n\n.tg-row-idoc:hover .tg-sticky {\n  background: #bbf7d0 !important;\n}\n\n/* Dark theme */\n[data-theme=\"dark\"] .tg-filters-bar,\n[data-theme=\"dark\"] .tg-report-radio {\n  background: var(--surface);\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .tg-radio-option.active {\n  background: var(--surface-2);\n  color: var(--primary);\n}\n\n[data-theme=\"dark\"] .tg-monitor-table th,\n[data-theme=\"dark\"] .tg-monitor-table td {\n  border-color: var(--border-strong);\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  .tg-monitor-page {\n    padding: 12px;\n  }\n\n  .tg-monitor-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .tg-report-radio {\n    width: 100%;\n    justify-content: stretch;\n  }\n\n  .tg-radio-option {\n    flex: 1;\n    justify-content: center;\n  }\n\n  .tg-filters-bar {\n    padding: 12px;\n  }\n\n  .tg-filters-bar .filter-label {\n    flex: 1 1 100%;\n  }\n\n  .tg-date-input,\n  .tg-filter-select,\n  .tg-ricef-select {\n    min-width: 0;\n    width: 100%;\n  }\n\n  .tg-filter-ricef {\n    max-width: none;\n  }\n\n  .tg-filter-actions {\n    width: 100%;\n  }\n\n  .tg-submit-btn,\n  .tg-download-btn {\n    flex: 1;\n  }\n\n  .tg-monitor-scroll {\n    max-height: calc(100dvh - 280px);\n  }\n\n  .tg-sticky-1 {\n    min-width: 160px;\n    max-width: 170px;\n    width: 160px;\n  }\n\n  .tg-sticky-2 {\n    left: 160px;\n    min-width: 100px;\n    max-width: 110px;\n    width: 100px;\n  }\n\n  .tg-sticky-3 {\n    left: 260px;\n    min-width: 90px;\n    max-width: 100px;\n    width: 90px;\n  }\n\n  .tg-th-metric {\n    min-width: 64px;\n    font-size: 9px;\n  }\n\n  .tg-monitor-table {\n    font-size: 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
